/* istanbul ignore file */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { PolicyInfoPage, PolicyDetailsPage, LocationsPage, SuccessPage, DeclarationPage, RiskAnalysisPage } from 'premier-capability-policyjob-react';
import CodegenWizard from './CodegenWizard';
import { CodegenContext } from './components/CodegenContext';
import QuotePage from './pages/Quote/QuotePage';
//import LiabilityCoveragesPage from "./pages/LiabilityCoverages/LiabilityCoveragesPage";
import CondominiumsPage from './pages/Condominiums/CondominiumsPage';
import LocRiskCoveragesPage from './pages/LocRiskCoverages/LocRiskCoveragesPage';
import RiskDetailsPage from './pages/RiskDetails/RiskDetailsPage';
import RiskAssistDwellingsPage from './pages/RiskAssistDwellings/RiskAssistDwellingsPage';
import PropertyInStoragePage from './pages/PropertyInStorage/PropertyInStoragePage';
import TinyHomesPage from './pages/TinyHomes/TinyHomesPage';
import PropertyDetailsPage from './pages/PersonalUmbrella/Property/PropertyDetailsPage';
import MobileHomePage from './pages/MobileHome/MobileHomePage';
import VehicleDetailsPage from './pages/PersonalUmbrella/Vehicles/VehicleDetailsPage';
import WatercraftDetailsPage from './pages/PersonalUmbrella/Watercraft/WatercraftDetailsPage';
import DriverDetailsPage from './pages/PersonalUmbrella/Drivers/DriverDetailsPage';

setComponentMapOverrides(
    {
        // wizard pages
        PremierPRPolicyDetailsPage: { component: 'PremierPRPolicyDetailsPage' },
        PremierPRLocationsPage: { component: 'PremierPRLocationsPage' },
        PremierPRCondominiumsPage: { component: 'PremierPRCondominiumsPage' },
		PremierPRTinyHomesPage: { component: 'PremierPRTinyHomesPage' },
		PremierPRVehicleDetailsPage: {component: 'PremierPRVehicleDetailsPage'},
        PremierPRPropertyDetailsPage: {component: 'PremierPRPropertyDetailsPage'},
        PremierPRWatercraftDetailsPage: {component: 'PremierPRWatercraftDetailsPage'},
        PremierPRDriverDetailsPage: {component: 'PremierPRDriverDetailsPage'},
        PremierPRPropertyInStoragePage: {component: 'PremierPRPropertyInStoragePage'},
        //PremierPRLiabilityCoveragesPage: { component: 'PremierPRLiabilityCoveragesPage' },
        PremierPRLocRiskCoveragesPage: { component: 'PremierPRLocRiskCoveragesPage'},
        PremierPRRiskAnalysisPage: { component: 'PremierPRRiskAnalysisPage' },
        PremierPRQuotePage: { component: 'PremierPRQuotePage' },
        PremierPRPolicyInfoPage: { component: 'PremierPRPolicyInfoPage' },
        PremierPRDeclarationPage: { component: 'PremierPRDeclarationPage' },
        PremierPRSuccessPage: { component: 'PremierPRSuccessPage' },
        PremierPRRiskAssistDwellingsPage: { component: 'PremierPRRiskAssistDwellingsPage'},
        PremierPRRiskDetailsPage: { component: 'PremierPRRiskDetailsPage'},
        PremierPRMobileHomesPage: { component: 'PremierPRMobileHomesPage'}
    },
    {
        // wizard pages
        PremierPRPolicyDetailsPage: PolicyDetailsPage,
        PremierPRLocationsPage: LocationsPage,
        PremierPRCondominiumsPage: CondominiumsPage,
        PremierPRTinyHomesPage: TinyHomesPage,
		PremierPRPropertyDetailsPage: PropertyDetailsPage,
        PremierPRVehicleDetailsPage: VehicleDetailsPage,
        PremierPRWatercraftDetailsPage: WatercraftDetailsPage,
        PremierPRDriverDetailsPage: DriverDetailsPage,
        PremierPRRiskDetailsPage: RiskDetailsPage,
        PremierPRRiskAssistDwellingsPage: RiskAssistDwellingsPage,
        PremierPRPropertyInStoragePage: PropertyInStoragePage,
        PremierPRMobileHomesPage: MobileHomePage,
        //PremierPRLiabilityCoveragesPage: LiabilityCoveragesPage,
        PremierPRLocRiskCoveragesPage: LocRiskCoveragesPage,
        PremierPRRiskAnalysisPage: RiskAnalysisPage,
        PremierPRQuotePage: QuotePage,
        PremierPRPolicyInfoPage: PolicyInfoPage,
        PremierPRDeclarationPage: DeclarationPage,
        PremierPRSuccessPage: SuccessPage
    }
);

export { CodegenWizard, CodegenContext };
